var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.34 3.43255L14.4375 0.500047C14.3678 0.429751 14.2848 0.373955 14.1934 0.335878C14.102 0.297802 14.004 0.278198 13.905 0.278198C13.806 0.278198 13.708 0.297802 13.6166 0.335878C13.5252 0.373955 13.4422 0.429751 13.3725 0.500047C13.2328 0.640569 13.1544 0.830658 13.1544 1.0288C13.1544 1.22694 13.2328 1.41702 13.3725 1.55755L16.0425 4.25005H0.75C0.551088 4.25005 0.360322 4.32906 0.21967 4.46972C0.0790176 4.61037 0 4.80113 0 5.00005H0C0 5.19896 0.0790176 5.38972 0.21967 5.53038C0.360322 5.67103 0.551088 5.75005 0.75 5.75005H16.0875L13.3725 8.45755C13.3022 8.52727 13.2464 8.61022 13.2083 8.70161C13.1703 8.79301 13.1507 8.89104 13.1507 8.99005C13.1507 9.08906 13.1703 9.18709 13.2083 9.27848C13.2464 9.36987 13.3022 9.45283 13.3725 9.52255C13.4422 9.59284 13.5252 9.64864 13.6166 9.68672C13.708 9.72479 13.806 9.7444 13.905 9.7444C14.004 9.7444 14.102 9.72479 14.1934 9.68672C14.2848 9.64864 14.3678 9.59284 14.4375 9.52255L17.34 6.61255C17.7614 6.19067 17.998 5.6188 17.998 5.02255C17.998 4.42629 17.7614 3.85442 17.34 3.43255Z",
    fill: "url(#paint0_linear_1965_71)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1965_71",
    x1: -1.06352,
    y1: -0.152083,
    x2: 10.829,
    y2: 19.9307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0237219,
    stopColor: "#FA96C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156443,
    stopColor: "#FF669B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904397,
    stopColor: "#BD8DE8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/Arrow_Right.2cbf898717ce4eb7e253c22a7d5b9d11.svg";
export { ForwardRef as ReactComponent };